// extracted by mini-css-extract-plugin
export default {"wrapper":"ScrollTopButton_wrapper__BBVMX","visible":"ScrollTopButton_visible__p6pUd"};